module.exports = __webpack_public_path__ + "static/media/juan.9bb8c575.jpg";